import { render, staticRenderFns } from "./tableTdPop.vue?vue&type=template&id=93f60a6c&scoped=true"
import script from "./tableTdPop.vue?vue&type=script&lang=js"
export * from "./tableTdPop.vue?vue&type=script&lang=js"
import style0 from "./tableTdPop.vue?vue&type=style&index=0&id=93f60a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f60a6c",
  null
  
)

export default component.exports